import {ImageKey} from "@/shared/utils/preload";

export interface IGame {
    hit: boolean,
    type: PuckType
}

export enum PuckType {
    BASIC = 'BASIC',
    GOLDEN = 'GOLDEN',
    FIRE = 'FIRE',
}

export interface IShoot {
    nextPuckType: PuckType,
}

export enum GameState {
    init = 'init',
    await = 'await',
    active = 'active',
    pause = 'pause',
    kick = 'kick',
    fireAnim = 'fireAnim',
    kickEnd = 'kickEnd'
}

export enum SpriteConfigName {
    square = 'square',
    player = 'player',
    goalkeeper = 'goalkeeper',
    gate = 'gate',
    puck = 'puck',
}

export interface AreaConfig {
    width: number;
    height: number;
    baseWidth: number;
    baseHeight: number;
    x: number;
    y: number;
}

export interface SpriteConfig {
    name: SpriteConfigName;
    width: number;
    height: number;
    x: number;
    y: number;
    anchor: number;
    speed: number;
    visible: boolean;
    image: string;
    baseWidth: number;
    baseHeight: number;
}

export type SpriteConfigBasic = {
    baseWidth: number;
    baseHeight: number;
    speed: number;
    imageKey: ImageKey;
    type: PuckType;
};
